import { useState } from 'react';

import { Link as RoutingLink } from 'react-router-dom';

import * as Yup from 'yup';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, Alert, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// components
import Iconify from '../../components/iconify';
import FormProvider, { RHFTextField } from '../../components/hook-form';

// ----------------------------------------------------------------------

export default function AuthLoginForm() {
  const { login } = useAuthContext();

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    mobile: Yup.string().required('نام کاربری الزامی است'),
    password: Yup.string().required('رمز عبور الزامی است'),
  });

  const defaultValues = {
    mobile: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = methods;

  const inputSx = {
    '& input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px rgba(30,20,5,0.0) inset !important',
      caretColor: '#fff',
      borderRadius: 'inherit',
      transition: 'background-color 9999s ease-in-out 0s',
    },
  };

  const onSubmit = async (data) => {
    try {
      await login(data.mobile, data.password);
    } catch (error) {
      console.error(error);
      reset();

      setError('afterSubmit', {
        ...error,
        message: 'نام کاربری یا رمز عبور اشتباه است',
      });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2} dir="rtl">
        {!!errors.afterSubmit && (
          <Alert severity="error" variant="outlined" sx={{ textAlign: 'right' }}>
            {errors.afterSubmit.message}
          </Alert>
        )}

        <RHFTextField
          name="mobile"
          label="نام کاربری"
          fullWidth
          sx={inputSx}
        />

        <RHFTextField
          name="password"
          label="رمز عبور"
          fullWidth
          type={showPassword ? 'text' : 'password'}
          sx={inputSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitSuccessful || isSubmitting}
          sx={{
            mt: 2,
            py: 1.4,
            borderRadius: 2,
            fontWeight: 700,
            bgcolor: '#03AB51',
            color: '#fff',
            boxShadow: 'none',
            '&:hover': {
              bgcolor: '#017229',
              boxShadow: 'none',
            },
          }}
        >
          ورود
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
